module.exports = __webpack_public_path__ + "static/media/Delay Modeler Low Gain VR.76505f9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Delay Modeler Low Gain VR.mp3
// module id = beuz
// module chunks = 12